import React from 'react';
import { Section, Container, Card } from '../common';
import { Clock, Users, XCircle, TrendingDown } from 'lucide-react';

const Problem = () => {
  return (
    <Section id="problema" className="bg-white border-top border-bottom py-5 py-lg-6">
      <Container>
        <div className="row justify-content-center text-center mb-5" data-aos="fade-up">
          <div className="col-lg-8">
            <span className="badge bg-danger bg-opacity-10 text-danger px-3 py-2 rounded-pill mb-3 fw-bold">
              Desafios do Dia a Dia
            </span>
            <h2 className="fw-bold mb-4 display-5 text-dark">
              Seu restaurante ainda perde pedidos?
            </h2>
            <p className="lead text-secondary fs-4">
              Atender pedidos manualmente e organizar comandas no papel pode custar caro para o seu negócio.
            </p>
          </div>
        </div>
        
        <div className="row g-4 justify-content-center">
          <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
            <Card className="h-100 border-0 shadow-sm p-4 bg-light hover-danger-border transition-all hover-lift">
              <div className="d-flex align-items-center mb-4">
                <div className="bg-danger bg-opacity-10 text-danger p-3 rounded-3 me-3">
                  <XCircle size={32} />
                </div>
                <h3 className="h5 fw-bold mb-0">Pedidos errados</h3>
              </div>
              <p className="text-secondary mb-0">
                Anotações manuais levam a erros na cozinha, desperdício de insumos e clientes insatisfeitos com o pedido trocado.
              </p>
              <div className="mt-4 pt-3 border-top border-danger border-opacity-10">
                <small className="text-danger fw-bold d-flex align-items-center">
                  <TrendingDown size={14} className="me-1" /> Prejuízo direto no bolso
                </small>
              </div>
            </Card>
          </div>

          <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="200">
            <Card className="h-100 border-0 shadow-sm p-4 bg-light hover-danger-border transition-all hover-lift">
              <div className="d-flex align-items-center mb-4">
                <div className="bg-danger bg-opacity-10 text-danger p-3 rounded-3 me-3">
                  <Clock size={32} />
                </div>
                <h3 className="h5 fw-bold mb-0">Demora no WhatsApp</h3>
              </div>
              <p className="text-secondary mb-0">
                O cliente não quer esperar. Se você demora para responder, ele simplesmente fecha o chat e pede no concorrente.
              </p>
              <div className="mt-4 pt-3 border-top border-danger border-opacity-10">
                <small className="text-danger fw-bold d-flex align-items-center">
                  <TrendingDown size={14} className="me-1" /> Perda de clientes fiéis
                </small>
              </div>
            </Card>
          </div>

          <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="300">
            <Card className="h-100 border-0 shadow-sm p-4 bg-light hover-danger-border transition-all hover-lift">
              <div className="d-flex align-items-center mb-4">
                <div className="bg-danger bg-opacity-10 text-danger p-3 rounded-3 me-3">
                  <Users size={32} />
                </div>
                <h3 className="h5 fw-bold mb-0">Caos na Operação</h3>
              </div>
              <p className="text-secondary mb-0">
                Equipe sobrecarregada com anotações, telefone tocando e mensagens chegando. O erro humano é inevitável.
              </p>
              <div className="mt-4 pt-3 border-top border-danger border-opacity-10">
                <small className="text-danger fw-bold d-flex align-items-center">
                  <TrendingDown size={14} className="me-1" /> Baixa produtividade
                </small>
              </div>
            </Card>
          </div>
        </div>

        <div className="row justify-content-center mt-5" data-aos="zoom-in">
          <div className="col-lg-10">
            <div className="bg-primary-custom p-4 p-md-5 rounded-4 shadow-deep d-flex flex-column flex-md-row align-items-center justify-content-between text-dark">
              <div className="mb-4 mb-md-0 text-center text-md-start pe-md-4">
                <h4 className="fw-bold mb-2 h3">A tecnologia pode resolver tudo isso.</h4>
                <p className="mb-0 opacity-75 fs-5">Pare de perder dinheiro e comece a automatizar sua operação hoje mesmo.</p>
              </div>
              <a href="#funcionalidades" className="btn btn-dark rounded-pill px-5 py-3 fw-bold text-nowrap hover-lift">
                Ver solução completa
              </a>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Problem;
